import { WRONG_CREDENTIALS_ERROR } from "../../services/API/auth/login/errors/error-codes.constants";
import {
  DEVICE_NOT_FOUND_ERROR,
  DEVICE_UPDATE_ERROR,
} from "../../services/API/devices/errors/codes.constants.error";
import ApiError from "../../services/API/errors/ApiError";
import {
  ROOM_NOT_FOUND_ERROR,
  SWAP_ROOM_ERROR,
  GUESTY_LISTING_ALREADY_LINKED_ERROR,
} from "../../services/API/rooms/errors";
import { GuestyListingAlreadyLinkedError } from "../../services/API/rooms/errors/guesty-listing-already-linked.error";
import {
  LINK_CUSTOMER_GUESTY_ERROR,
  LINK_CUSTOMER_KROSS_ERROR,
  LINK_CUSTOMER_KROSS_INVALID_CREDENTIALS_ERROR,
  LINK_CUSTOMER_KROSS_CONNECTION_ERROR,
  LINK_CUSTOMER_KROSS_API_ERROR,
  LINK_CUSTOMER_ICNEA_INVALID_OWNER_ERROR,
  LINK_CUSTOMER_ICNEA_NOT_CONFIGURED_ERROR,
  LINK_CUSTOMER_ICNEA_ERROR,
} from "../../services/API/third-parties/errors";
import { useNotification } from "../contexts";
import { useInternationalization } from "../contexts";

const useApiError = () => {
  const { error } = useNotification();
  const { t } = useInternationalization();

  const handleErrors = (err: ApiError | GuestyListingAlreadyLinkedError) => {
    let message = "errors.unexpected";

    if (err.code === WRONG_CREDENTIALS_ERROR) {
      message = "errors.wrong-credentials";
    } else if (err.code === DEVICE_NOT_FOUND_ERROR) {
      message = "errors.device-not-found";
    } else if (err.code === DEVICE_UPDATE_ERROR) {
      message = "errors.device-update";
    } else if (err.code === SWAP_ROOM_ERROR) {
      message = "errors.swap-room";
    } else if (err.code === ROOM_NOT_FOUND_ERROR) {
      message = "errors.no-room";
    } else if (err.code === LINK_CUSTOMER_GUESTY_ERROR) {
      message = "errors.link-customer-guesty";
    } else if (err.code === LINK_CUSTOMER_KROSS_ERROR) {
      message = "errors.link-customer-kross";
    } else if (err.code === LINK_CUSTOMER_KROSS_INVALID_CREDENTIALS_ERROR) {
      message = "errors.link-customer-kross-invalid-credentials";
    } else if (err.code === LINK_CUSTOMER_KROSS_CONNECTION_ERROR) {
      message = "errors.link-customer-kross-connection";
    } else if (err.code === LINK_CUSTOMER_KROSS_API_ERROR) {
      message = "errors.link-customer-kross-api";
    } else if (err.code === LINK_CUSTOMER_ICNEA_INVALID_OWNER_ERROR) {
      message = "errors.link-customer-icnea-invalid-owner";
    } else if (err.code === LINK_CUSTOMER_ICNEA_NOT_CONFIGURED_ERROR) {
      message = "errors.link-customer-icnea-not-configured";
    } else if (err.code === LINK_CUSTOMER_ICNEA_ERROR) {
      message = "errors.link-customer-icnea";
    } else if (err.code === GUESTY_LISTING_ALREADY_LINKED_ERROR) {
      if (err instanceof GuestyListingAlreadyLinkedError && err.conflictingRoomName) {
        // Use dynamic message with room name
        const translatedMessage = t("errors.guesty-listing-already-linked-with-room");
        error(translatedMessage.replace("{roomName}", err.conflictingRoomName));
        return;
      } else {
        message = "errors.guesty-listing-already-linked";
      }
    }

    error(t(message));
  };

  return {
    handleErrors,
  };
};

export default useApiError;
